import { Edit02 } from '@untitledui/icons';
import type { Ref } from 'react';

import { RowActionButton } from './RowActionButton';

/**
 * EditPencil — hover-reveal pencil button that starts inline editing.
 *
 * Shared by HighlightCardShell (opens the "Update {label}" modal) and
 * InlineEditableFieldRow (starts inline overview-row editing). A thin
 * naming wrapper over {@link RowActionButton}, which owns the reveal,
 * sizing, and click-isolation behaviour for every button in a row's action
 * cluster — see that component for the details.
 */
export interface EditPencilProps {
  onEdit: () => void;
  label: string;
  /** The rendered button — the row hands focus back to it after an edit closes. */
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;
}

export function EditPencil({ onEdit, label, ref }: EditPencilProps) {
  return (
    <RowActionButton ref={ref} icon={Edit02} label={label} onClick={onEdit} />
  );
}
